import React, { ReactChild } from 'react';
import styled from 'styled-components';

interface WhiteButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactChild;
  width?: number;
  height?: number;
  borderRadius?: number;
}

function WhiteButton({ children, width, height, borderRadius, ...buttonProps }: WhiteButtonProps) {
  const disabled = buttonProps.disabled;
  return (
    <StyledWhiteButton
      width={width}
      height={height}
      borderRadius={borderRadius}
      disabled={disabled}
      {...buttonProps}
    >
      {children}
    </StyledWhiteButton>
  );
}

const StyledWhiteButton = styled.button<{
  width?: number;
  height?: number;
  borderRadius?: number;
  disabled?: boolean;
}>`
  display: flex;
  width: ${({ width }) => width && `${width}px`};
  height: ${({ height }) => height && `${height}px`};
  justify-content: center;
  align-items: center;
  border-radius: ${({ borderRadius }) => borderRadius && `${borderRadius}px`};
  border: 1px solid rgba(0, 0, 0, 0.23);
  &:hover {
    background-color: #f9f9fb;
  }
  &:disabled {
    pointer-events: none; // 이벤트를 비활성화된 버튼에도 허용
    background-color: transparent;
  }
`;

export default WhiteButton;
